import { useEffect, useState } from 'react';

// Același prag ca breakpoint-ul `md` din Tailwind.
const MOBILE_QUERY = '(max-width: 767px)';

/** `true` cât timp fereastra e sub breakpoint-ul de desktop. */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
